export default __webpack_public_path__ + "static/media/Destination5.8db742a0.png";